import { TranRecordModel } from "./tran-record.model";

export class UpdateTranInfoModel {
    tmpTran: TranRecordModel
    sglLinkCost: number
    strLinkFix: string
    sglLinkUnit: number
    strChkCost: string
    sglProcPrice: number
    constructor(
        tmpTran: TranRecordModel,
        sglLinkCost: number,
        strLinkFix: string,
        sglLinkUnit: number,
        strChkCost: string,
        sglProcPrice: number,
    ) {
        this.tmpTran = tmpTran
        this.sglLinkCost = sglLinkCost
        this.strLinkFix = strLinkFix
        this.sglLinkUnit = sglLinkUnit
        this.strChkCost = strChkCost
        this.sglProcPrice = sglProcPrice
    }
}